import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { useEffect, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
const IncomeSourceCard = ({
  amount,
  type,
  selectedSource,
  changeSelectedSource,
}) => {
  const { _t } = useTranslator();
  const [isActive, setIsActive] = useState(selectedSource == type);

  useEffect(() => {
    setIsActive(selectedSource == type);
  }, [selectedSource]);

  const handleChange = () => {
    changeSelectedSource(type);
  };

  return (
    <div
      className={`income-source-card-wrapper mb-3 ${
        isActive ? "income-source-card-wrapper-active" : ""
      }`}
      onClick={handleChange}
    >
      <div className="d-flex align-items-center about-source">
        <div className="default-checkbox d-flex align-items-center justify-content-center">
          {isActive && <CheckOutlinedIcon />}
        </div>
        <div className="d-flex flex-column">
          <h4>
            {type.startsWith("payslip:")
              ? (() => {
                  const temp = type.split(":");
                  return `${_t(temp[0])}:${temp[1]}`;
                })()
              : _t(type)}
          </h4>
          <h6>€{amount}</h6>
        </div>
      </div>
    </div>
  );
};

export default IncomeSourceCard;
